export const filtroPlanoDiarioDefault = {
    Carteiras: [],
    Coordenacoes: [],
    Destinos: [],
    Familias: [],
    FamiliasRotuladas: [],
    IdUsuarioResponsavel: null,
    ItensSemRisco: false
}